/* LA Sports Cards motion engine — GSAP 3.15 + ScrollTrigger (loaded before this file).
   Ownership model: any element this file animates is first adopt()ed — its Dawn
   scroll-reveal classes are stripped synchronously, before animations.js registers
   its IntersectionObserver at DOMContentLoaded — so exactly one system owns a node.
   If GSAP or this file fails to load, nothing is adopted and the theme runs stock. */
(function () {
  'use strict';
  var VER = 'lsc-motion v9';
  function releaseBoot() { document.documentElement.classList.remove('lsc-hdr-boot'); }
  if (!window.gsap || !window.ScrollTrigger) { releaseBoot(); return; }
  if (window.Shopify && window.Shopify.designMode) { releaseBoot(); return; }
  gsap.registerPlugin(ScrollTrigger);
  try { console.info('[LSC]', VER); } catch (e) {}

  var MOB = window.matchMedia('(max-width: 749px)');
  var S = { on: false, revealed: false, megaClosedAt: 0 };
  var CLEAR = 'transform,opacity,visibility';
  var DAWN = ['scroll-trigger', 'animate--slide-in', 'animate--fade-in', 'scroll-trigger--offscreen', 'scroll-trigger--cancel'];

  function adopt(el) {
    if (!el || !el.classList) return el;
    for (var i = 0; i < DAWN.length; i++) el.classList.remove(DAWN[i]);
    el.removeAttribute('data-cascade');
    return el;
  }
  /* Adopt el plus any Dawn-revealed ancestor (defuses wrapper double-motion and
     base.css slider transform:inherit); ancestors are adopted but left static. */
  function adoptDeep(el) {
    var p = el && el.parentElement;
    while (p && p.id !== 'MainContent' && p.tagName !== 'BODY') {
      if (p.classList && p.classList.contains('scroll-trigger')) adopt(p);
      p = p.parentElement;
    }
    /* Dawn's classes also sit on DESCENDANTS (rich-text children, list titles):
       strip them too, or Dawn double-animates inside our moving wrapper */
    if (el && el.querySelectorAll) {
      var kids = el.querySelectorAll('.scroll-trigger');
      for (var i = 0; i < kids.length; i++) adopt(kids[i]);
    }
    return adopt(el);
  }
  function q(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function inView(el, pad) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight - (pad || 0) && r.bottom > 0;
  }
  function whenReady(fn) {
    /* deferred scripts run at readyState 'interactive', BEFORE later deferred
       scripts (facets.js etc.) — so defer to DCL, which fires after all of them */
    if (document.readyState === 'complete') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function clearOf(t) { return function () { gsap.set(t, { clearProps: CLEAR }); }; }
  /* load-time entrances: hide NOW (pre-paint, so no flash), but only START the
     tween after the first painted frame — a tween created pre-paint has its
     start eaten when GSAP's rAF clock jumps forward on the first render */
  function afterPaint(fn) { requestAnimationFrame(function () { requestAnimationFrame(fn); }); }
  /* has this tab actually RENDERED anything? In a background tab first paint is
     deferred indefinitely, and performance.now() keeps ticking while rAF is
     frozen — so wall-clock "slow load" guards misfire there. Only trust
     elapsed-time checks when a paint has really happened. */
  function painted() { return performance.getEntriesByType && performance.getEntriesByType('paint').length > 0; }
  /* run fn now if the tab is visible, else the moment it becomes visible */
  function whenVisible(fn) {
    if (document.visibilityState !== 'hidden') return fn();
    document.addEventListener('visibilitychange', function onV() {
      if (document.visibilityState === 'hidden') return;
      document.removeEventListener('visibilitychange', onV);
      fn();
    });
  }

  /* ---------- synchronous adoption pass (must beat Dawn's DCL observer) ---------- */
  var firstSection = document.querySelector('#MainContent > .shopify-section'); /* hero — never adopted */
  /* ...but only when it actually IS a hero: on single-section templates (search)
     or grid-first templates the "first section" is the whole page — no exclusion */
  if (firstSection && (firstSection.querySelector('#product-grid, .product-grid') || !firstSection.nextElementSibling)) firstSection = null;
  var editorial = !!document.querySelector('#MainContent .article-template, #MainContent .blog__posts, #MainContent .customer');
  function ok(el) { return !(firstSection && firstSection.contains(el)); }

  var GRID_ITEMS = [], BRAND_ITEMS = [], BLOCKS = [], IWT = [];
  if (!editorial) {
    /* second selector: the search template's results grid is a plain ul.grid
       inside div#product-grid — it never carries the product-grid class */
    GRID_ITEMS = q('.product-grid > li.grid__item, #product-grid ul.grid:not(.product-grid) > li.grid__item').filter(ok).map(adoptDeep);
    BRAND_ITEMS = q('ul.collection-list > li.collection-list__item').filter(ok).map(adoptDeep);
    BLOCKS = q('.title-wrapper-with-link, .collection__title.title-wrapper, .center.collection__view-all, .rich-text__blocks, .multicolumn-list__item, .store-location, .footer-block, .footer__content-bottom, .giftpromo__head, .giftpromo__tier, .giftpromo__actions').filter(ok).map(adoptDeep);
    IWT = q('.image-with-text').filter(ok).map(adoptDeep);
  }
  var RELATED = document.querySelector('product-recommendations.related-products');
  if (RELATED) adopt(RELATED); /* its grid items inject later — see asyncReveals() */

  /* ---------- entry 1: reveal engine ---------- */
  function batchReveal(items, setVars, toVars) {
    var hidden = items.filter(function (el) { return !inView(el, 40); });
    if (!hidden.length) return;
    gsap.set(hidden, setVars);
    ScrollTrigger.batch(hidden, {
      /* clamp() so triggers near the document bottom (footer) can still fire */
      start: 'clamp(top 88%)', once: true, batchMax: MOB.matches ? 6 : 8,
      onEnter: function (b) {
        gsap.to(b, Object.assign({}, toVars, { onComplete: clearOf(b) }));
      }
    });
  }

  function reveals() {
    var y = MOB.matches ? 16 : 24;
    var dur = MOB.matches ? 0.5 : 0.55;
    var st = MOB.matches ? 0.05 : 0.06;
    batchReveal(GRID_ITEMS, { autoAlpha: 0, y: y },
      { autoAlpha: 1, y: 0, duration: dur, ease: 'power3.out', stagger: st, overwrite: 'auto' });
    batchReveal(BLOCKS, { autoAlpha: 0, y: y },
      { autoAlpha: 1, y: 0, duration: dur, ease: 'power3.out', stagger: st, overwrite: 'auto' });

    /* department signs (homepage category headings, snippets/slab-label.liquid).
       The sign itself is never hidden (lsc-lab.js buildIgnition keeps category
       headings visible by design); only the decorations move: the edge bar draws
       down, the bottom rule draws across, the chips rise in with a stagger.
       transform/opacity only; nothing loops. Backstops force everything visible if
       the trigger never fires. */
    /* edge + light in ONE svg (flush by construction). The static edge (line + halo) and
       the light (4 white tints at the exact line width + 2 blurred glows, all centred on
       one moving point) share the same path: M cx 0 V cy H W — square corner, mitered.
       The edge draws in on reveal (dashoffset), then the light pulse runs on a sine.inOut
       ease once per cycle. Rebuilt on resize; paused off-screen / hidden tab. */
    function slabLight(s) {
      var svg = s.querySelector('.slab__trace'), lb = s.querySelector('.slab__bar'), lr = s.querySelector('.slab__rule');
      if (!svg || !lb || !lr || s._lscLight) return;
      s._lscLight = true;
      var NS = 'http://www.w3.org/2000/svg';
      var cycle = parseFloat(s.getAttribute('data-sweep')) || 6;
      var SPEED = MOB.matches ? 250 : 360;   /* average px per second along the edge */
      var tl = null, active = false, started = false, revealed = false;
      var edge = [];
      function mk(cls, d, width, opacity) {
        var el = document.createElementNS(NS, 'path');
        el.setAttribute('class', cls); el.setAttribute('d', d); el.setAttribute('stroke-width', width);
        if (opacity != null) el.setAttribute('opacity', opacity);
        return el;
      }
      function build() {
        var wasPlaying = tl && !tl.paused();
        if (tl) tl.kill();
        while (svg.firstChild) svg.removeChild(svg.firstChild);
        var box = s.getBoundingClientRect();
        var T = lr.getBoundingClientRect().height;        /* exact line thickness */
        var W = lr.getBoundingClientRect().width;
        var cx = T / 2, cy = box.height - T / 2;
        svg.setAttribute('viewBox', '0 0 ' + box.width + ' ' + box.height);
        var d = 'M ' + cx + ' 0 V ' + cy + ' H ' + W;
        /* static edge: one crisp stroke, exactly the bar's width */
        var line = mk('line', d, T);
        svg.appendChild(line);
        edge = [line];
        var total = line.getTotalLength();
        if (!revealed) {
          edge.forEach(function (el) { el.style.strokeDasharray = total + ' ' + total; el.style.strokeDashoffset = total; });
        }
        /* light */
        var g = document.createElementNS(NS, 'g'); g.setAttribute('class', 'light'); svg.appendChild(g);
        var L = MOB.matches ? 300 : 520;
        /* 12 tints, lengths shrinking geometrically, each faint: stacked they give a smooth
           bell of brightness peaking at ~65% lighter in the centre, falling to nothing at the ends */
        var spec = [];
        for (var i = 0; i < 12; i++) spec.push(['tint', L * Math.pow(0.82, i), T, 0.085]);
        var strokes = spec.map(function (sp) {
          var el = mk(sp[0], d, sp[2], sp[3]);
          el.style.strokeDasharray = sp[1] + ' ' + (total + sp[1] * 2);
          g.appendChild(el);
          return { el: el, len: sp[1] };
        });
        var Lmax = L;
        var c = { v: -Lmax / 2 };
        function place() {
          for (var i = 0; i < strokes.length; i++) strokes[i].el.style.strokeDashoffset = (strokes[i].len / 2 - c.v) + 'px';
        }
        place();
        var travel = (total + Lmax) / SPEED;
        var rest = Math.max(1.2, cycle - travel);
        tl = gsap.timeline({ repeat: -1, repeatDelay: rest, paused: true });
        tl.set(c, { v: -Lmax / 2, onUpdate: place })
          .set(g, { opacity: 0 }, 0)
          .to(c, { v: total + Lmax / 2, duration: travel, ease: 'sine.inOut', onUpdate: place }, 0)
          .to(g, { opacity: 1, duration: travel * 0.14, ease: 'sine.out' }, 0)
          .to(g, { opacity: 0, duration: travel * 0.3, ease: 'sine.in' }, travel * 0.7);
        if (wasPlaying) tl.play();
      }
      function sync() { if (!tl) return; if (started && active && !document.hidden) tl.play(); else tl.pause(); }
      /* reveal: draw the edge from the top of the bar to the end of the rule, then start the light */
      s._lscReveal = function (animated) {
        if (revealed) return;
        revealed = true;
        if (animated) {
          gsap.to(edge, { strokeDashoffset: 0, duration: 0.9, ease: 'power3.out', stagger: 0.05,
            onComplete: function () { edge.forEach(function (el) { el.style.strokeDasharray = ''; el.style.strokeDashoffset = ''; }); started = true; sync(); } });
        } else {
          edge.forEach(function (el) { el.style.strokeDasharray = ''; el.style.strokeDashoffset = ''; });
          started = true; sync();
        }
      };
      build();
      ScrollTrigger.create({ trigger: s, start: 'top bottom', end: 'bottom top', onToggle: function (self) { active = self.isActive; sync(); } });
      active = inView(s, 0); sync();
      document.addEventListener('visibilitychange', sync);
      var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { build(); sync(); }, 200); });
    }
    q('.collection__title .slab').forEach(function (s) {
      var bar = s.querySelector('.slab__bar'), rule = s.querySelector('.slab__rule');
      var chips = q('.slab__chip', s);
      if (!bar || !rule) return;
      slabLight(s); /* builds the svg edge (hidden until revealed) + the light timeline */
      if (inView(s, 40)) { s.classList.add('is-on'); if (s._lscReveal) s._lscReveal(false); return; } /* on screen at load: never hide */
      var done = false;
      var parts = [bar, rule].concat(chips);
      function show() {
        if (done) return; done = true;
        gsap.to(bar, { scaleY: 1, duration: 0.5, ease: 'power3.out', onComplete: clearOf(bar) });
        gsap.to(rule, { scaleX: 1, duration: 0.7, ease: 'power3.out', delay: 0.1, onComplete: clearOf(rule) });
        if (s._lscReveal) s._lscReveal(true);
        s.classList.add('is-on');
        if (chips.length) gsap.to(chips, { autoAlpha: 1, y: 0, duration: 0.45, ease: 'power3.out', stagger: 0.05, delay: 0.2, overwrite: 'auto', onComplete: clearOf(chips) });
      }
      gsap.set(bar, { scaleY: 0 });
      gsap.set(rule, { scaleX: 0 });
      if (chips.length) gsap.set(chips, { autoAlpha: 0, y: 8 });
      ScrollTrigger.create({ trigger: s, start: 'clamp(top 85%)', once: true, onEnter: show });
      setTimeout(function () { if (!done && inView(s, 40)) show(); }, 3500);
      setTimeout(function () { if (!done) { done = true; gsap.set(parts, { clearProps: 'all' }); s.classList.add('is-on'); if (s._lscReveal) s._lscReveal(false); } }, 8000);
    });

    /* brand wall (collection list) — accent beat #1 */
    var bw = BRAND_ITEMS.filter(function (el) { return !inView(el, 40); });
    if (bw.length) {
      gsap.set(bw, { autoAlpha: 0, y: y, scale: 0.96 });
      ScrollTrigger.create({
        trigger: bw[0].parentElement, start: 'clamp(top 88%)', once: true,
        onEnter: function () {
          gsap.to(bw, { autoAlpha: 1, y: 0, scale: 1, duration: 0.55, ease: 'back.out(1.7)', stagger: { each: 0.06, from: 'center' }, overwrite: 'auto', onComplete: clearOf(bw) });
        }
      });
    }

    /* image-with-text choreography */
    IWT.forEach(function (s) {
      if (inView(s, 40)) return;
      var media = s.querySelector('.image-with-text__media');
      var txt = q('.image-with-text__content > *', s).slice(0, 5);
      if (!media && !txt.length) return;
      var all = (media ? [media] : []).concat(txt);
      var tl = gsap.timeline({
        scrollTrigger: { trigger: s, start: 'clamp(top 85%)', once: true },
        onComplete: clearOf(all)
      });
      if (media) { gsap.set(media, { autoAlpha: 0, x: -24 }); tl.to(media, { autoAlpha: 1, x: 0, duration: 0.6, ease: 'power3.out' }); }
      if (txt.length) { gsap.set(txt, { autoAlpha: 0, y: 16 }); tl.to(txt, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power3.out', stagger: 0.12 }, media ? '-=0.35' : 0); }
    });

    /* pokemon showcase (no Dawn classes — conflict-free) */
    var pkT = document.querySelector('.pkshow__bigtitle');
    if (pkT && !inView(pkT, 40)) {
      gsap.set(pkT, { autoAlpha: 0, y: 28 });
      ScrollTrigger.create({ trigger: pkT, start: 'clamp(top 85%)', once: true, onEnter: function () {
        gsap.to(pkT, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'back.out(1.4)', onComplete: clearOf(pkT) });
      } });
    }
    var pkC = q('.pkshow__cols > .pkshow__col');
    if (pkC.length && !inView(pkC[0], 40)) {
      gsap.set(pkC, { autoAlpha: 0, y: 32 });
      ScrollTrigger.create({ trigger: '.pkshow__cols', start: 'clamp(top 82%)', once: true, onEnter: function () {
        gsap.to(pkC, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power3.out', stagger: 0.15, onComplete: clearOf(pkC) });
      } });
    }
    /* perf: pause the 38s pkshow marquee while offscreen */
    var pk = document.querySelector('.pkshow');
    if (pk) ScrollTrigger.create({
      trigger: pk, start: 'top bottom', end: 'bottom top',
      onToggle: function (self) { pk.classList.toggle('pkshow--offscreen', !self.isActive); }
    });
  }

  /* ---------- entry 5: PDP info-column timeline + sale-badge beat ---------- */
  function pdpIntro() {
    var info = document.querySelector('.product__info-container');
    if (!info || (painted() && performance.now() > 3000)) return; /* visible slow load already painted — never re-hide */
    adoptDeep(info);
    var kids = q(':scope > *', info).filter(function (n) {
      return n.tagName !== 'SCRIPT' && n.tagName !== 'STYLE';
    }).slice(0, 6);
    if (!kids.length) return;
    gsap.set(kids, { autoAlpha: 0, y: 18 });
    afterPaint(function () {
      var tl = gsap.timeline({ onComplete: clearOf(kids) }); /* non-optional: column is position:sticky w/ fixed descendants */
      tl.to(kids, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power3.out', stagger: 0.06 });
      var badge = document.querySelector('.price--large .badge');
      if (badge && badge.offsetParent !== null) {
        tl.from(badge, { scale: 0.6, autoAlpha: 0, duration: 0.4, ease: 'back.out(2)', transformOrigin: 'center', clearProps: CLEAR }, '-=0.15'); /* accent beat #2 */
      }
    });
  }

  /* ---------- entry 8: /cart load entrance + empty-state reveal ---------- */
  function cartIntro() {
    var wrap = document.querySelector('cart-items');
    if (!wrap) return;
    var emptyReveal = function () {
      if (document.querySelector('.cart-item--vanish')) return;
      var warn = q('.cart__warnings > *');
      if (warn.length) gsap.from(warn, { y: 12, autoAlpha: 0, duration: 0.45, ease: 'expo.out', stagger: 0.08, clearProps: 'all' });
    };
    if (!(painted() && performance.now() > 3000)) {
      if (wrap.classList.contains('is-empty')) {
        emptyReveal();
      } else {
        var title = document.querySelector('cart-items .title-wrapper-with-link');
        var rows = q('table.cart-items tbody tr.cart-item').slice(0, 8);
        var totals = document.querySelector('#main-cart-footer .totals');
        if (title) gsap.set(title, { y: 12, autoAlpha: 0 });
        if (rows.length) gsap.set(rows, { autoAlpha: 0 }); /* FLIP snapshot surface — opacity ONLY */
        if (totals) gsap.set(totals, { y: 12, autoAlpha: 0 });
        afterPaint(function () {
          var tl = gsap.timeline({ onComplete: clearOf(rows.concat(title || [], totals || [])) });
          if (title) tl.to(title, { y: 0, autoAlpha: 1, duration: 0.4, ease: 'power3.out' });
          if (rows.length) tl.to(rows, { autoAlpha: 1, duration: 0.5, ease: 'power3.out', stagger: 0.05 }, title ? '-=0.2' : 0);
          if (totals) tl.to(totals, { y: 0, autoAlpha: 1, duration: 0.45, ease: 'power3.out' }, '-=0.25');
        });
      }
    }
    var wasEmpty = wrap.classList.contains('is-empty');
    new MutationObserver(function () {
      var is = wrap.classList.contains('is-empty');
      if (is && !wasEmpty && S.on) emptyReveal();
      wasEmpty = is;
    }).observe(wrap, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- header entrance: logo -> nav -> icons ----------
     Children only — NEVER the header/sticky-header containers (their transforms
     belong to Dawn's scroll show/hide state machine). Nav tweens the li's link/
     summary, not the li: a transformed li becomes the containing block for the
     absolutely-positioned mega-menu panel inside it. */
  function headerIntro() {
    var header = document.querySelector('header.header') || document.querySelector('.section-header header');
    if (!header) { releaseBoot(); return; }
    var t = [];
    var logo = header.querySelector('.header__heading-link, .header__heading');
    if (logo) t.push(logo);
    /* The nav pills used to be staged here too (.header__inline-menu
       .header__menu-item), blooming center-out after the chrome phase. Removed
       at the owner's request: it left the primary navigation invisible until
       ~0.9s and not fully up until ~1.9s on every load. The pills now paint
       solid from first paint — see the matching note on the boot-state rule in
       custom-cards.css, which no longer hides them either. Keep the two in
       sync: hiding them in one place without the other either reintroduces the
       delay or strands them invisible. */
    t = t.concat(q('.header__icons > *', header));
    var burger = header.querySelector('header-drawer details > summary');
    if (burger) t.push(burger);
    /* stagger budget on VISIBLE elements only */
    t = t.filter(function (el) { return el.getClientRects().length > 0; });
    window.__LSC = window.__LSC || {};
    if (!t.length) { window.__LSC.hdrSkip = 'no-targets'; releaseBoot(); return; }
    /* yield to the 2.5s CSS failsafe ONLY when this tab has actually painted —
       in a background tab the clock runs but nothing has rendered, so the
       entrance must survive and play at first sight instead (this exact guard,
       as a bare wall-clock check, is why the owner never saw the animation:
       preview links opening into background tabs always tripped it) */
    if (painted() && performance.now() > 2200) { window.__LSC.hdrSkip = 'late-visible-load'; releaseBoot(); return; }
    /* single phase: the chrome (logo/icons/burger) drops in. The pill bloom that
       used to follow it is gone — see the note above. */
    /* takeover order matters: inline hidden state FIRST, then drop the boot
       class — the failsafe's forwards-fill may have completed invisibly in a
       background tab, and it beats inline styles while its class still matches */
    gsap.set(t, { opacity: 0, y: -14 });
    releaseBoot();
    window.__LSC.hdrSet = Math.round(performance.now());
    /* background tab: hold the armed state and play at the first moment the
       user can actually see it */
    whenVisible(function () {
      afterPaint(function () {
        window.__LSC.hdrStart = Math.round(performance.now());
        gsap.to(t, {
          opacity: 1, y: 0, duration: 0.55, ease: 'power3.out',
          stagger: { amount: 0.2 }, overwrite: 'auto',
          onComplete: function () {
            window.__LSC.hdrDone = Math.round(performance.now());
            gsap.set(t, { clearProps: 'transform,opacity' });
          }
        });
      });
    });
  }

  /* nav pill hover/press/open states are pure CSS (custom-cards.css) — the
     underline glow element was removed at the owner's request */

  /* ---------- entry 11: hero slideshow text choreography ---------- */
  function slideTargets(slide) { return q('.banner__heading, .banner__text, .banner__buttons', slide); }
  function activeSlide(comp) {
    return comp.querySelector('.slideshow__slide[aria-hidden="false"]') || comp.querySelector('.slideshow__slide');
  }
  function motionSlideshows() {
    return q('slideshow-component').filter(function (comp) {
      if (comp.closest('.announcement-bar, .utility-bar')) return false;
      return !(firstSection && firstSection.contains(comp)); /* first section stays Dawn's */
    });
  }
  function heroFirstPaint() {
    if (painted() && performance.now() > 3000) return; /* visible slow load already painted */
    motionSlideshows().forEach(function (comp) {
      /* below-fold carousels are handled by heroScrollIn() — a load-time entrance
         there would play to an empty screen and leave nothing for the scroll */
      if (!inView(comp, 40)) return;
      var slide = activeSlide(comp);
      if (!slide) return;
      adoptDeep(slide); /* Dawn's classes sit on the slide's text wrapper — single owner */
      var t = slideTargets(slide);
      if (t.length) {
        gsap.set(t, { autoAlpha: 0, y: 16 });
        afterPaint(function () {
          gsap.to(t, { autoAlpha: 1, y: 0, duration: 0.55, ease: 'power3.out', stagger: 0.09, clearProps: 'all' });
        });
      }
    });
  }
  /* A slideshow that is NOT the hero — the homepage tournament carousel now sits
     below the product rows — needs the treatment every other below-fold block
     gets: reveal on scroll-in, and hold Dawn's autoplay until then so the viewer
     arrives on slide 1 instead of wherever a 7s timer had wandered off to. */
  function heroScrollIn() {
    motionSlideshows().forEach(function (comp) {
      if (inView(comp, 40)) return;
      var slide = activeSlide(comp);
      if (!slide) return;

      /* Dawn starts autoplay in connectedCallback with no viewport gate. pause()
         just clears the interval — safe to call from outside; the play/pause
         BUTTON's own state is untouched, and it is off-screen while we hold. */
      var slider = comp.querySelector('[data-autoplay]');
      var holding = !!(slider && slider.getAttribute('data-autoplay') === 'true' && typeof comp.pause === 'function');
      if (holding) comp.pause();

      adoptDeep(slide);
      var t = slideTargets(slide);
      if (t.length) gsap.set(t, { autoAlpha: 0, y: 20 });

      var done = false;
      function enter(animate) {
        if (done) return;
        done = true;
        if (t.length) {
          if (animate) {
            gsap.to(t, {
              autoAlpha: 1, y: 0, duration: 0.6, ease: 'power3.out',
              stagger: 0.09, overwrite: 'auto', clearProps: 'all'
            });
          } else {
            gsap.set(t, { clearProps: 'all' });
          }
        }
        /* let the entrance read before the timer takes over. S.on guard: if the
           viewer flipped on reduced motion in the meantime, leave it paused —
           that is what the reduce branch wants anyway (WCAG 2.2.2). */
        if (holding) gsap.delayedCall(animate ? 1.2 : 0, function () { if (S.on) comp.play(); });
      }

      ScrollTrigger.create({
        trigger: comp, start: 'clamp(top 82%)', once: true,
        onEnter: function () { enter(true); }
      });

      /* Backup path. Never time-based: a timer would un-hide the carousel while
         it is still off-screen and spend the reveal on nobody. This only fires
         when the section is genuinely on screen, so if ScrollTrigger ever misses
         it (stale refresh after an async section resize) the content still
         arrives — just without the stagger. */
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          enter(false);
        });
        io.observe(comp);
      }
    });
  }
  whenReady(function () { /* slideChanged doesn't bubble — bind each component directly */
    q('slideshow-component').forEach(function (comp) {
      if (comp.closest('.announcement-bar, .utility-bar')) return;
      comp.addEventListener('slideChanged', function (e) {
        if (!S.on || !e.detail || !e.detail.currentElement) return;
        adoptDeep(e.detail.currentElement); /* claim from Dawn before tweening */
        var t = slideTargets(e.detail.currentElement);
        /* whole containers only — tournament-slides.js rewrites .banner__text content async */
        if (t.length) gsap.fromTo(t, { autoAlpha: 0, y: 14 }, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power3.out', stagger: 0.08, overwrite: 'auto', clearProps: 'all' });
      });
    });
  });

  /* ---------- entry 2: facet/sort AJAX re-render orchestration ---------- */
  whenReady(function () {
    /* facets.js declares the class lexically (never a window property) — resolve
       it through the custom-element registry after all deferred scripts have run.
       NEVER read window.FacetFiltersForm first: the facets form element has
       id="FacetFiltersForm", and named-element access shadows it with a DOM node. */
    var F = window.customElements && customElements.get('facet-filters-form');
    if (!F || typeof F.renderProductGridContainer !== 'function') {
      F = window.FacetFiltersForm; /* last resort, only if it's really the class */
      if (!F || typeof F.renderProductGridContainer !== 'function') return;
    }
    var orig = F.renderProductGridContainer;
    F.renderProductGridContainer = function (html) {
      gsap.killTweensOf('#product-grid .grid__item');
      var out = orig.call(this, html);
      /* Dawn's re-enroll after a facet render re-observes the WHOLE document and
         re-adds --offscreen to anything not intersecting — including the already-
         seen banner above the grid, which then replays its entrance on scroll-up.
         Cancel the replay for revealed elements OUTSIDE the grid container. */
      setTimeout(function () {
        q('.scroll-trigger--offscreen').forEach(function (el) {
          if (!el.closest('#ProductGridContainer')) el.classList.add('scroll-trigger--cancel');
        });
      }, 60);
      /* re-adopt every fresh item: even if Dawn's buggy re-enroll marks them
         --offscreen, the hidden selector can no longer match */
      var items = q('#product-grid .grid__item').map(adoptDeep); /* collection: ul#product-grid>li; search: div#product-grid ul li */
      if (S.on) {
        var vis = items.filter(function (el) { return inView(el, 0); }).slice(0, 12);
        if (vis.length) gsap.from(vis, { autoAlpha: 0, y: 10, duration: 0.35, ease: 'power2.out', stagger: { each: MOB.matches ? 0.02 : 0.03, grid: 'auto' }, overwrite: 'auto', clearProps: 'opacity,transform,visibility' });
        var counts = q('#ProductCount, #ProductCountDesktop');
        if (counts.length) gsap.from(counts, { autoAlpha: 0, y: 4, duration: 0.2, ease: 'power1.out', clearProps: 'all' });
        var empty = document.querySelector('.collection--empty .title-wrapper');
        if (empty) gsap.from(empty, { autoAlpha: 0, y: 12, duration: 0.4, ease: 'power2.out', clearProps: 'all' });
      }
      return out;
    };
  });

  /* ---------- entry 3: checkout press acknowledgment (CSS-first) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"]');
    if (!btn) return; /* NEVER preventDefault — feedback plays while the browser navigates */
    btn.classList.add('lsc-checkout-pressed');
    setTimeout(function () { btn.style.pointerEvents = 'none'; }, 0); /* double-submit guard, after dispatch */
    /* failsafe: if the navigation is cancelled (Esc/Stop on a slow checkout),
       pageshow never fires on this document — never leave checkout dead. 3s is
       plenty for a real navigation to leave this page (was 8s, an eternity at
       the highest-value click of the funnel). */
    setTimeout(function () {
      btn.style.pointerEvents = '';
      btn.classList.remove('lsc-checkout-pressed');
    }, 3000);
  }, true);
  window.addEventListener('pageshow', function (e) {
    q('.lsc-checkout-pressed').forEach(function (b) {
      b.classList.remove('lsc-checkout-pressed');
      b.style.pointerEvents = '';
    });
    if (e.persisted) ScrollTrigger.refresh(); /* bfcache restore */
  });

  /* ---------- entry 7: mobile sticky ATC bar slide-up ---------- */
  whenReady(function () {
    requestAnimationFrame(function () { /* after its inline script re-parents the bar to <body> */
      var bar = document.querySelector('[data-sticky-atc]');
      if (!bar) return;
      var was = bar.classList.contains('sticky-atc--visible');
      new MutationObserver(function () {
        var is = bar.classList.contains('sticky-atc--visible');
        if (is && !was && S.on) {
          /* entrance only; hide stays instant (drawer-over-bar kill switch is display-based) */
          gsap.fromTo(bar, { yPercent: 110 }, { yPercent: 0, duration: 0.28, ease: 'power3.out', overwrite: 'auto', clearProps: 'transform' });
        }
        was = is;
      }).observe(bar, { attributes: true, attributeFilter: ['class'] });
    });
  });

  /* ---------- entry 6: cart feedback suite ---------- */
  function moneyOf(txt) {
    var m = txt && txt.match(/\d[\d.,]*/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : null;
  }
  var lastTotal = null;
  function readTotal() {
    var n = document.querySelector('#main-cart-footer .totals__total-value, cart-drawer .totals__total-value');
    return n ? moneyOf(n.textContent) : null;
  }
  whenReady(function () { lastTotal = readTotal(); });

  /* PUB_SUB_EVENTS/subscribe are top-level lexical bindings from constants.js/
     pubsub.js (earlier deferred scripts) — never window properties */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      var t0 = performance.now();
      var base = lastTotal; /* snapshot: a concurrently-finishing count-up mutates
                               lastTotal, which used to end this poll early */
      (function wait() { /* the totals node is replaced by the re-render — poll until
                            the rendered total differs (or 500ms), then animate */
        var now = readTotal();
        if (now !== null && now === base && performance.now() - t0 < 500) return requestAnimationFrame(wait);
        cartFeedback(ev);
      })();
    });
  }
  var activeCountUp = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  function cartFeedback(ev) {
    var nodes = q('#main-cart-footer .totals__total-value, cart-drawer .totals__total-value');
    var to = nodes.length ? moneyOf(nodes[0].textContent) : null;
    if (S.on && to !== null && lastTotal !== null && to !== lastTotal) {
      var from = lastTotal;
      nodes.forEach(function (node) {
        var txt = node.textContent, m = txt.match(/\d[\d.,]*/);
        if (!m) return;
        var dec = (m[0].split('.')[1] || '').length;
        var grouped = m[0].indexOf(',') > -1;
        /* one in-flight count-up per node: rapid successive cart updates used to
           interleave two tweens writing the same text node (flickering total) */
        var prev = activeCountUp && activeCountUp.get(node);
        if (prev) prev.kill();
        var proxy = { v: from };
        var tw = gsap.to(proxy, { v: to, duration: 0.5, ease: 'power2.out', snap: { v: 0.01 }, onUpdate: function () {
          var s = grouped
            ? proxy.v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec })
            : proxy.v.toFixed(dec);
          node.textContent = txt.replace(m[0], s);
        } });
        if (activeCountUp) activeCountUp.set(node, tw);
      });
    }
    lastTotal = to;
    /* line-price settle — changed row only. pubsub delivers the payload object
       directly (not wrapped in .data); prefer the on-page cart over the drawer */
    var vid = ev && (ev.variantId || (ev.data && ev.data.variantId));
    if (S.on && vid) {
      var scope = document.querySelector('cart-items') || document.querySelector('cart-drawer') || document;
      var input = scope.querySelector('[data-quantity-variant-id="' + vid + '"]');
      var row = input && input.closest('.cart-item');
      if (row && !/cart-item--(vanish|arrive|reappear)/.test(row.className)) {
        var w = row.querySelector('.cart-item__price-wrapper');
        if (w) gsap.fromTo(w, { autoAlpha: 0.4, scale: 1.04 }, { autoAlpha: 1, scale: 1, duration: 0.3, ease: 'power2.out', transformOrigin: 'right center', clearProps: 'all', overwrite: 'auto' });
      }
    }
  }
  /* error shake + FLIP-safety kill — observers live on STABLE hosts (the custom
     elements / section wrappers survive innerHTML re-renders; their insides don't) */
  function shake(box) {
    if (!S.on || !box || !box.textContent.trim() || gsap.getTweensOf(box).length) return;
    gsap.fromTo(box, { autoAlpha: 0.4 }, { autoAlpha: 1, duration: 0.2 });
    gsap.to(box, { keyframes: { x: [-5, 5, -3, 3, 0] }, duration: 0.4, ease: 'power2.out', clearProps: 'transform' });
  }
  whenReady(function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(function (muts) {
      /* ignore mutations from our own count-up textContent writes in the totals,
         or the kill below murders the settle/count-up mid-flight every frame */
      var structural = false;
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        var el = t.nodeType === 1 ? t : t.parentElement;
        if (!el || !el.closest('.totals, .cart-drawer__footer')) { structural = true; break; }
      }
      if (structural) gsap.killTweensOf('.cart-item *'); /* FLIP snapshots must never read stale inline transforms */
      shake(drawer.querySelector('#CartDrawer-CartErrors'));
      var lineErr = drawer.querySelector('.cart-item__error-text');
      if (lineErr && lineErr.textContent.trim()) shake(lineErr.closest('.cart-item__error') || lineErr);
    }).observe(drawer, { childList: true, characterData: true, subtree: true });

    var pageErr = document.getElementById('cart-errors');
    var host = pageErr && (pageErr.closest('.shopify-section') || pageErr.parentElement);
    if (host) new MutationObserver(function () {
      shake(document.getElementById('cart-errors')); /* re-query: re-renders replace it */
    }).observe(host, { childList: true, characterData: true, subtree: true });
  });

  /* ---------- entries 9 + 10: async injections + header chrome ---------- */
  function revealInjected(items, section) {
    if (!items.length) return;
    if (!inView(section || items[0], 0)) {
      gsap.set(items, { autoAlpha: 0, y: 20 });
      ScrollTrigger.create({ trigger: section || items[0], start: 'clamp(top 85%)', once: true, onEnter: function () {
        gsap.to(items, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power3.out', stagger: 0.06, onComplete: clearOf(items) });
      } });
      /* these fetch-injected items exist AFTER grid-reveal-safety snapshotted the
         page, so the sitewide net can't see them — carry our own backstop */
      setTimeout(function () {
        items.forEach(function (el) {
          var cs = getComputedStyle(el);
          if (cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) {
            gsap.set(el, { clearProps: 'opacity,visibility,transform' });
          }
        });
      }, 3500);
    } else {
      gsap.from(items, { autoAlpha: 0, y: 20, duration: 0.45, ease: 'power3.out', stagger: 0.06, clearProps: CLEAR });
    }
  }
  whenReady(function () {
    /* related products (fetch-injected after Dawn's container reveal) */
    if (RELATED) {
      var fire = function () {
        if (!S.on) return;
        var items = q('.grid__item', RELATED).map(adopt);
        var head = RELATED.querySelector('.related-products__heading');
        if (head) items.unshift(adopt(head));
        revealInjected(items, RELATED);
      };
      if (RELATED.querySelector('.grid__item')) fire();
      else {
        var ro = new MutationObserver(function () {
          if (!RELATED.querySelector('.grid__item')) return;
          ro.disconnect();
          fire();
        });
        ro.observe(RELATED, { childList: true, subtree: true });
      }
    }
    /* recently viewed (hidden attr removed once populated) */
    var rv = document.querySelector('recently-viewed');
    if (rv) new MutationObserver(function () {
      if (rv.hasAttribute('hidden') || !S.on || rv._lscDone) return;
      rv._lscDone = true;
      gsap.from(q('.category-navigator__item', rv), { autoAlpha: 0, y: 14, duration: 0.45, ease: 'power3.out', stagger: 0.04, clearProps: CLEAR });
    }).observe(rv, { attributes: true, attributeFilter: ['hidden'] });
    /* category navigator lazy tab panels */
    q('.category-navigator__panel').forEach(function (panel) {
      new MutationObserver(function () {
        if (!S.on) return;
        var items = q('li.category-navigator__item', panel);
        if (!items.length) return;
        gsap.killTweensOf(items);
        gsap.fromTo(panel, { opacity: 0.55 }, { opacity: 1, duration: 0.2, clearProps: 'opacity' });
        gsap.from(items, { autoAlpha: 0, y: 14, duration: 0.4, ease: 'power2.out', stagger: 0.03, clearProps: CLEAR, overwrite: 'auto' });
      }).observe(panel, { childList: true });
    });
    /* recent-searches panel (inserted into the search form on focus) */
    q('.header__search').forEach(function (hs) {
      new MutationObserver(function (muts) {
        if (!S.on) return;
        muts.forEach(function (m) {
          Array.prototype.forEach.call(m.addedNodes, function (n) {
            if (n.nodeType !== 1) return;
            var panel = n.classList && n.classList.contains('recent-searches') ? n : (n.querySelector ? n.querySelector('.recent-searches') : null);
            if (!panel || gsap.getTweensOf(panel).length) return;
            gsap.from(panel, { autoAlpha: 0, y: -6, duration: 0.2, ease: 'power2.out', clearProps: 'all' });
            var its = q('.recent-searches__item', panel);
            if (its.length) gsap.from(its, { autoAlpha: 0, y: -4, duration: 0.18, ease: 'power2.out', stagger: 0.025, clearProps: 'all' });
          });
        });
      }).observe(hs, { childList: true, subtree: true });
    });
    /* predictive search results (if enabled) */
    var ps = document.querySelector('predictive-search');
    if (ps) new MutationObserver(function () {
      if (!S.on) return;
      var items = q('.predictive-search__list-item', ps).slice(0, 10);
      if (!items.length) return;
      gsap.killTweensOf('.predictive-search__list-item');
      gsap.from(items, { autoAlpha: 0, y: 6, duration: 0.22, ease: 'power2.out', stagger: { amount: 0.12 }, clearProps: 'all', overwrite: 'auto' });
    }).observe(ps, { childList: true, subtree: true });
  });

  /* mega-menu cascade, mobile drawer children, search modal, PDP accordions —
     one capture-phase toggle listener (toggle doesn't bubble; capture still descends).
     ARIA/state attrs stay Dawn-owned; tweens are decoration on child elements only. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS') return;
    /* PDP accordion content (caret is CSS-owned; height stays native/instant) */
    if (d.closest('.product__accordion')) {
      if (!S.on || !d.open) return;
      var c = d.querySelector('.accordion__content');
      if (c && c.children.length) gsap.from(q(':scope > *', c).slice(0, 8), { y: 8, autoAlpha: 0, duration: 0.28, ease: 'power2.out', stagger: 0.04, clearProps: 'all', overwrite: 'auto' });
      return;
    }
    /* mega menu — panel is CSS-owned (!important); children only. Opacity ONLY
       (no visibility: keyboard/AT keep the links), no delay, and NO re-stagger
       when gliding between adjacent top-level menus — that read as flicker. */
    if (d.classList.contains('mega-menu')) {
      var items = q('.mega-menu__list > li', d);
      if (!items.length) return;
      if (d.open && S.on) {
        if (performance.now() - S.megaClosedAt < 250) {
          gsap.set(items, { clearProps: 'all' }); /* warm hop between menus: instant */
        } else {
          /* ONE soft unit — a per-item stagger swept left-to-right across the
             panel's columns and read as a glitch on first open */
          gsap.fromTo(items, { y: 6, opacity: 0 }, { y: 0, opacity: 1, duration: 0.32, ease: 'power2.out', overwrite: 'auto', clearProps: 'all' });
        }
        var content = d.querySelector('.mega-menu__content');
        if (content && !content._lscClose) {
          content._lscClose = new MutationObserver(function () {
            if (content.classList.contains('is-closing')) { gsap.killTweensOf(items); gsap.set(items, { clearProps: 'all' }); }
          });
          content._lscClose.observe(content, { attributes: true, attributeFilter: ['class'] });
        }
      } else if (!d.open) {
        S.megaClosedAt = performance.now();
        gsap.killTweensOf(items); gsap.set(items, { clearProps: 'all' });
      }
      return;
    }
    /* mobile nav drawer — panel translateX is class-driven CSS; children compose */
    if (d.id === 'Details-menu-drawer-container') {
      /* tween the li's direct link/summary children, never the li itself — a
         transformed li becomes the containing block for its absolute submenu panel */
      var links = q('.menu-drawer__menu > li > a, .menu-drawer__menu > li > details > summary', d);
      if (!links.length) return;
      if (d.open && S.on) {
        gsap.fromTo(links, { x: 12, autoAlpha: 0 }, { x: 0, autoAlpha: 1, duration: 0.3, ease: 'power2.out', stagger: 0.03, delay: 0.15, clearProps: 'all', overwrite: 'auto' });
      } else if (!d.open) { gsap.killTweensOf(links); gsap.set(links, { clearProps: 'all' }); }
      return;
    }
    /* search modal — children only; close stays instant (focus-trap timing sacred).
       Opacity ONLY (autoAlpha's visibility:hidden blurs the just-focused input and
       dismisses the mobile keyboard), and never touch the focused element's branch. */
    if (S.on && d.open && d.closest('.header__search')) {
      var sc = d.querySelector('.search-modal__content');
      if (sc && sc.children.length) {
        var safeKids = q(':scope > *', sc).filter(function (n) { return !n.contains(document.activeElement); });
        if (safeKids.length) gsap.from(safeKids, { y: 8, opacity: 0, duration: 0.3, ease: 'power3.out', stagger: 0.05, delay: 0.1, clearProps: 'all', overwrite: 'auto' });
      }
    }
  }, true);

  /* ---------- motion-preference contexts ---------- */
  var mm = gsap.matchMedia();
  mm.add('(prefers-reduced-motion: no-preference)', function () {
    S.on = true;
    window.__LSC = window.__LSC || {};
    window.__LSC.engine = VER;
    window.__LSC.motion = true;
    if (!S.revealed) { /* one-shot: never re-hide content on a live OS toggle back */
      S.revealed = true;
      headerIntro();
      reveals();
      pdpIntro();
      cartIntro();
      heroFirstPaint();
      /* deferred to DCL: heroScrollIn calls into the slideshow custom element
         (pause/play), which global.js only defines further down the defer queue */
      whenReady(heroScrollIn);
    }
    return function () { S.on = false; if (window.__LSC) window.__LSC.motion = false; };
  });
  mm.add('(prefers-reduced-motion: reduce)', function () {
    releaseBoot(); /* belt-and-braces: boot is already skipped under reduce at parse */
    /* WCAG 2.2.2 fix: pause hero autoplay under reduced motion (Dawn never checks) */
    whenReady(function () {
      q('.slideshow__autoplay').forEach(function (b) {
        if (!b.classList.contains('slideshow__autoplay--paused')) b.click();
      });
    });
  });

  /* debug beacon UI lives in theme.liquid's inline boot script so it reports
     even when this engine fails to load — this file only feeds window.__LSC */
})();
